export default __webpack_public_path__ + "static/media/fold.dc1037cb.png";